// src/services/publicReservoApi.js
import axios from 'axios';
import { getApiBaseUrl } from '../utils/apiBaseUrl';

const API_URL = getApiBaseUrl();

// Instância pública (sem Authorization)
export const apiPublicReservo = axios.create({
  baseURL: `${API_URL}/reservo`,
  withCredentials: false,
});

const unwrapPublicReservoResponse = (payload, fallback = undefined) => {
  if (payload && typeof payload === 'object' && !Array.isArray(payload)) {
    const keys = Object.keys(payload);
    const hasDataField = Object.prototype.hasOwnProperty.call(payload, 'data');
    const envelopeKeys = new Set(['data', 'success', 'status', 'message']);
    const looksLikeEnvelope = hasDataField && keys.every((key) => envelopeKeys.has(key));

    if (looksLikeEnvelope) {
      return payload.data ?? fallback;
    }
  }

  return payload ?? fallback;
};

// --------- RESTAURANTE ----------
export const getPublicRestauranteReservo = async (slug) => {
  const { data } = await apiPublicReservo.get(`/public/${slug}/nome`);
  return unwrapPublicReservoResponse(data);
};

// --------- SALAS ----------
export const listPublicSalas = async (slug) => {
  const { data } = await apiPublicReservo.get(`/public/${slug}/salas`);
  return unwrapPublicReservoResponse(data, []);
};

// --------- MESAS ----------
export const listPublicMesas = async (slug) => {
  const { data } = await apiPublicReservo.get(`/public/${slug}/mesas`);
  return unwrapPublicReservoResponse(data, []);
};

// --------- OBJETOS ----------
export const listPublicObjetos = async (slug) => {
  const { data } = await apiPublicReservo.get(`/public/${slug}/objetos`);
  return unwrapPublicReservoResponse(data, []);
};

// --------- RESERVAS ----------
export const createPublicReserva = async (slug, reservaData) => {
  const { data } = await apiPublicReservo.post(`/public/${slug}/reservas`, reservaData);
  return unwrapPublicReservoResponse(data);
};

export const getPublicReservaByToken = async (token) => {
  const { data } = await apiPublicReservo.get(`/public/reservas/${encodeURIComponent(token)}`);
  return unwrapPublicReservoResponse(data);
};

export const updatePublicReservaByToken = async (token, reservaData) => {
  const { data } = await apiPublicReservo.put(`/public/reservas/${encodeURIComponent(token)}`, reservaData);
  return unwrapPublicReservoResponse(data);
};

export const cancelPublicReservaByToken = async (token) => {
  const { data } = await apiPublicReservo.post(`/public/reservas/${encodeURIComponent(token)}/cancelar`);
  return unwrapPublicReservoResponse(data);
};

// --------- FILA DE ESPERA ----------
export const createPublicWaitlistEntry = async (slug, waitlistData) => {
  const { data } = await apiPublicReservo.post(`/public/${slug}/fila`, waitlistData);
  return unwrapPublicReservoResponse(data);
};

export const getPublicWaitlistEntryByToken = async (token) => {
  const { data } = await apiPublicReservo.get(`/public/waitlist/${encodeURIComponent(token)}`);
  return unwrapPublicReservoResponse(data);
};

export const cancelPublicWaitlistEntryByToken = async (token) => {
  const { data } = await apiPublicReservo.post(`/public/waitlist/${encodeURIComponent(token)}/cancelar`);
  return unwrapPublicReservoResponse(data);
};

// --------- DISPONIBILIDADE ----------
export const checkPublicAvailability = async (slug, params) => {
  const { data } = await apiPublicReservo.get(`/public/${slug}/disponibilidade`, { params });
  return unwrapPublicReservoResponse(data);
};

// --------- HORÁRIOS ----------
export const listPublicHorarios = async (slug) => {
  const { data } = await apiPublicReservo.get(`/public/${slug}/horarios`);
  return unwrapPublicReservoResponse(data, []);
};

// --------- CONFIGURAÇÕES ----------
export const getPublicReservoSettings = async (slug) => {
  const { data } = await apiPublicReservo.get(`/public/${slug}/settings`);
  return unwrapPublicReservoResponse(data);
};
